import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import { Toast } from 'vant';
import 'vant/lib/index.css';
import '@/plugins/TsaUi/index.js';
import 'amfe-flexible';
import './assets/css/common.css'
import './assets/css/iconfont.css'
import {set, get } from '@/utils/localStorage'
import '@/utils/permission';
import Clipboard from 'clipboard';
import VideoPlayer from 'vue-video-player'
import MetaInfo from 'vue-meta-info'
import filters from "@/filter"; // vue过滤器
import '@/icons/index.js'
// 全局过滤器
Object.keys(filters).forEach((filterName) => {
    Vue.filter(filterName, filters[filterName]);
});
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.config.productionTip = false

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

Vue.use(Vant)
Vue.use(MetaInfo)
import TsaEnvironmentCheck from '@/plugins/EnvironmentCheck'
Vue.use(TsaEnvironmentCheck);
import TsaAgreementPreviewDialog from '@/plugins/AgreementPreviewDialog'
Vue.use(TsaAgreementPreviewDialog);
Vue.prototype.$setlocalStorage = set;
Vue.prototype.$getlocalStorage = get;
Vue.prototype.Clipboard = Clipboard;

Toast.setDefaultOptions({ duration: 3000 });

new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('render-event'))
    }
}).$mount('#app')